import PropTypes from 'prop-types';

import StarRating from '../StarRating/StarRating';
import Title from '../../Title/Title';
import Text from '../../Text/Text';

import './ReviewsItem.styles.scss';

const ReviewsItem = ({ avatar, name, rating, text, username, setRef }) => {
    return (
        <li className="reviews-item flex flex--column align-center" ref={setRef}>
            <div className="reviews-item__avatar flex">
                <img src={avatar} alt={name} />
            </div>

            {/*<StarRating rating={rating} />*/}

            <Title name="reviews-item" type="h3" size="smaller">
                {name}
            </Title>

            <Text name="review-item" grey={true} additionalClasses={['reviews-item__username']}>
                {username}
            </Text>

            <Text name="reviews-item">{text}</Text>
        </li>
    );
};

ReviewsItem.propTypes = {
    avatar: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    rating: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
    setRef: PropTypes.func,
};

export default ReviewsItem;
